import React, {
  useEffect,
  useCallback,
} from 'react';
import {
  useParams,
} from 'react-router-dom';
import {
  getStatus,
} from 'redux-resource';

import {
  shallowEqual,
  useSelector,
  useDispatch,
} from 'react-redux';

import {
  coreActions,
  coreSelectors,
} from '@gymcloud/core';

import {
  getUiState,
} from 'web-selectors';

import {
  Spinner,
  NotFound,
  SignUpWithPurchaseForm,
} from 'web-components';
import {
  Flex,
} from 'web-styled';

type Props = {
  isPlan?: boolean,
  isTest?: boolean,
  requestWithSlug?: boolean,
};

const SignUpWithPurchase = ({
  isPlan,
  isTest,
  requestWithSlug,
}: Props) => {
  const params = useParams();
  const slug = params.slug || '';
  const id = Number((slug!).split('-')[0]);
  const resourceType = isPlan ? 'productPlans' : 'products';
  const dispatch = useDispatch();
  const mapState = useCallback(state => {
    const product = coreSelectors.getResourceByProp('products', 'slug', slug)(state);
    const productPlan = coreSelectors.getResourceByProp('productPlans', 'slug', slug)(state);

    const productOrPlan = requestWithSlug
      ? product || productPlan
      : coreSelectors.getResourceById(resourceType, id)(state);

    return {
      getEntityStatus: getStatus(
        state,
        `${resourceType}.requests.getEntity.status`,
        true,
      ),
      getProductStatus: getStatus(
        state,
        'products.requests.getProductOrPlan.status',
        true,
      ),
      getProductPlanStatus: getStatus(
        state,
        'productPlans.requests.getProductOrPlan.status',
        true,
      ),
      namespace: getUiState('namespace')(state),
      productOrPlan,
    };
  }, [slug]);

  const {
    namespace,
    productOrPlan,
    getEntityStatus,
    getProductStatus,
    getProductPlanStatus,
  } = useSelector(mapState, shallowEqual);

  useEffect(() => {
    if (requestWithSlug) {
      dispatch(
        coreActions.requestProductOrPlanBySlug({
          qs: {
            namespace: namespace.symbol,
          },
          slug,
          resourceType: 'products',
        }),
      );
      dispatch(
        coreActions.requestProductOrPlanBySlug({
          qs: {
            namespace: namespace.symbol,
          },
          slug,
          resourceType: 'productPlans',
        }),
      );
    } else {
      dispatch(
        coreActions.requestFullEntity({
          id,
          resourceType,
        }),
      );
    }
  }, [slug]);

  const succeeded = requestWithSlug
    ? getProductStatus.succeeded || getProductPlanStatus.succeeded
    : getEntityStatus.succeeded;

  const pending = requestWithSlug
    ? getProductStatus.pending || getProductPlanStatus.pending
    : getEntityStatus.pending;

  const failed = requestWithSlug
    ? getProductStatus.failed && getProductPlanStatus.failed
    : getEntityStatus.failed;

  return (
    <>
      {succeeded && (
        <SignUpWithPurchaseForm
          item={productOrPlan}
          isPlan={!!productOrPlan.interval}
          isTest={isTest}
          namespace={namespace}
        />
      )}

      {pending && (
        <Flex
          fillSpace
          minHeight="400px"
          align="center"
          justify="center"
        >
          <Spinner message="Loading..." />
        </Flex>
      )}

      {failed && (
        <NotFound title={`Not Found (${slug})`} />
      )}
    </>
  );
};

SignUpWithPurchase.defaultProps = {
  isPlan: false,
  isTest: false,
  requestWithSlug: false,
};

export default SignUpWithPurchase;
